export default __webpack_public_path__ + "static/media/_DSC0849.8c7749e6.JPG";